<template>
<md-sidenav class="md-left" ref="printNav">
    <md-toolbar class="md-dense main-toolbar">
        <md-button class="md-icon-button" @click="back()">
            <md-icon>menu</md-icon>
        </md-button>
        <h3 class="md-title">Print Settings</h3>
    </md-toolbar>
            
    <md-layout md-flex="90" md-flex-offset="5">
        <p>Print Options coming soon</p>
<!--         <form novalidate @submit.stop.prevent="open">
            <div class="md-title">Print with Layers</div>
            <div class="md-subtitle">Defaults to visible layers</div>
            <md-switch v-model="allLayers" class="md-primary">All Layers</md-switch>
            <div class="md-title">Print with Notes</div>
            <md-switch v-model="allNotes" class="md-primary">All Notes</md-switch>
            <div class="md-title">Print with Cue Descriptions</div>
            <md-switch v-model="allDescriptions" class="md-primary">All Descriptions</md-switch>
            </br>
            <md-button class="md-raised md-primary" @click="print"><md-icon>file_download</md-icon>Print to PDF</md-button>         
        </form> -->
    </md-layout>
</md-sidenav>
</template>

<script>
import NavBus from '@/buses/nav';

const PrintNav = {
    name: 'CoreHeader',
    props: ['project'/* , 'selectedVersion' */],
    data: function() {
        return {
            allLayers: false,
            allNotes: false,
            allDescriptions: false
        };
    },
    methods: {
        closePrintNav() {
            this.$refs.printNav.close();
        },
        back() {
            this.closePrintNav();
            NavBus.$emit('main-nav.open');
        },
        print() {
            console.log('Print');
        }
    },
    created: function() {
        NavBus.$on('print-nav.open', () => {
            if (this.$refs.printNav) {
                this.$refs.printNav.open();
            }
        });
    }
};
export default PrintNav;

</script>

<style></style>


// WEBPACK FOOTER //
// nav.vue?126c60e6